import type { ReactNode, SVGProps } from 'react'

/** Boeken op een plank: het paneel Bronnen (R-50, ontwerp A van het invulscherm). */
export function BooksIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-5)', height: 'var(--nwo-space-sp-5)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <path d="M4 4v16" /><path d="M8 4v16" /><path d="M12 4v16" /><path d="m16 4.5 4 15" />
    </svg>
  )
}
